import { ClientRecord, ContractRecord, VendorRecord } from 'lib/DataModel'

import { isClickTab, isLinkTab, isRouteTab, Tab } from './Sidebar'
import SidebarTab from './SidebarTab'
import TabSectionHeading from './TabSectionHeading'
import SidebarLink from './SidebarLink'
import { MouseEventHandler } from 'react'

type RenderTabSectionPropsBase = {
  tabs: Tab[]
  showHeading?: boolean
  expandMacros: (path: string | undefined) => string | undefined
  onClick?: MouseEventHandler
  showLabels: boolean
  conditionProps: unknown
  getFeatureConfig: unknown
}

type RenderTabSectionPropsWithEntity<Entity extends ClientRecord | VendorRecord | ContractRecord> = RenderTabSectionPropsBase & {
  title: string
  entityType: Entity['type']
  entities?: Entity[]
  currentEntity?: Entity
  setCurrentEntity?: React.Dispatch<React.SetStateAction<Entity>>
}

type RenderTabSectionPropsWithTitle = RenderTabSectionPropsBase & {
  title: string
  entities?: never
  entityType?: never
  currentEntity?: never
  setCurrentEntity?: never
}

type RenderTabSectionProps<Entity extends ClientRecord | VendorRecord | ContractRecord> = RenderTabSectionPropsWithEntity<Entity> | RenderTabSectionPropsWithTitle

export default function createTabSection<T extends ClientRecord | VendorRecord | ContractRecord>({ title, tabs, entityType, entities, currentEntity, setCurrentEntity, expandMacros, onClick, showLabels, conditionProps, getFeatureConfig, showHeading = true }: RenderTabSectionProps<T>) {
  if(entities && entities.length === 0) {
    return null
  }

  return (
    <>
      {showHeading && (
        <TabSectionHeading title={title} entities={entities} currentEntity={currentEntity} setCurrentEntity={setCurrentEntity} entityType={entityType} />
      )}
      {tabs.map((tab, index) => {
        if(tab.condition && !tab.condition(conditionProps)) {
          return null
        }

        const onTabClick = isClickTab(tab) ? tab.onClick : undefined
        const url = isRouteTab(tab) ? tab.path : isLinkTab(tab) ? typeof(tab.url) === 'function' ? tab.url({ getFeatureConfig }) : tab.url : undefined

        return (
          <SidebarTab
            key={index}
            value={isRouteTab(tab) ? tab.path : ''}
            label={tab.label}
            component={SidebarLink}
            iconSrc={tab.icon}
            to={expandMacros(url) ?? '#'}
            onClick={(event: React.MouseEvent) => { onClick && onClick(event); onTabClick && onTabClick(event) }}
            showLabel={showLabels}
            tooltipText={tab.label}
          />
        )
      })}
    </>
  )
}
